/*
 *   File : basket-filter.js
 *   Author : https://evoqins.com
 *   Description : Basket filter modal component
 *   Integrations : 
 *   Version : 1.0.0
*/

import React, { useState } from 'react';

//Style
import style from "../../Styles/Component/modal.module.scss";

//Custom components
import { Icon } from '../Icon';
import { PrimaryButton, SecondaryButton } from '../Buttons';

const SubscriptionFilterModal = (props) => {

    return (
        <div className={`${style.e_basket_sort_modal} e-bg-white border-radius-16 p-3 position-absolute top-50px end-0 z-index-999 w-360px w-280px-res`}>
            <div className='pb-2 d-flex align-items-center justify-content-between'>
                <h6 className='mb-0 e-text-chinese-black e-alt-font-lato e-font-16 e-font-weight-700 line-height-24px'>
                    Filter
                </h6>
                {/* <div className='d-flex gap-1 align-items-center cursor-pointer'
                    onClick={props.handleClear}>
                    <span className='e-text-primary-color e-alt-font-lato e-font-14 e-font-weight-400 line-height-20px'>
                        Clear all
                    </span>
                    <Icon icon="clear-icon"
                        size="16px"
                        className="d-flex" />
                </div> */}
            </div>

            <div className={`${style.e_basket_filter_modal_body} overflow-scroll pb-2`}>
                <div className='pt-4'>
                    <p className='mb-0 e-text-chinese-black e-alt-font-lato e-font-14 e-font-weight-400 line-height-20px'>
                        Status
                    </p>
                    <p className='mb-0 e-text-philippine-gray e-alt-font-lato e-font-12 e-font-weight-400 line-height-18px'>
                        Choose your preference  based on your status
                    </p>

                    {/* Risk Type Options */}
                    <div className='mt-3 d-flex flex-column gap-12px'>
                        {props.activeStatus.map((option, key) => (
                            <div key={key} className=' d-flex gap-2 align-items-center cursor-pointer'
                                onClick={() => props.handleSelectStatus(option.id)}>
                                <Icon icon={props.selectedStatus === option.id ? "radio-active" : "radio-inactive"}
                                    size="1rem"
                                    className="d-flex" />
                                <p className='mb-0 e-text-chinese-black e-alt-font-lato e-font-14 e-font-weight-400 line-height-20px'>
                                    {option.label}
                                </p>
                            </div>
                        ))}
                    </div>
                </div>

                {/* Objectives */}
                {/* <div className='pt-4'>
                    <p className='mb-0 e-text-chinese-black e-alt-font-lato e-font-14 e-font-weight-400 line-height-20px'>
                        Type
                    </p>
                    <p className='mb-0 e-text-philippine-gray e-alt-font-lato e-font-12 e-font-weight-400 line-height-18px'>
                        Select the type of product you are interested in from the list below.
                    </p>

                    <div className='mt-3 d-flex flex-column gap-12px'>
                        {props.productType.map((option, key) => (
                            <div key={key} className=' d-flex gap-2 align-items-center cursor-pointer'
                                onClick={() => props.handleSelectProductType(option.id)}>
                                <Icon icon={props.selectedProductType === option.id ? "radio-active" : "radio-inactive"}
                                    size="1rem"
                                    className="d-flex" />
                                <p className='mb-0 e-text-chinese-black e-alt-font-lato e-font-14 e-font-weight-400 line-height-20px'>
                                    {option.label}
                                </p>
                            </div>
                        ))}
                    </div>
                </div> */}
            </div>

            {/* Custom buttons */}
            <div className='pt-2 d-flex justify-content-end gap-3'>
                <SecondaryButton name="Cancel"
                    className="bg-transparent"
                    padding="padding-40px-lr"
                    onPress={props.handleCancel} />
                <PrimaryButton name="Apply"
                    padding="padding-40px-lr"
                    onPress={props.handleApply} />
            </div>
        </div>
    )
}

export default SubscriptionFilterModal;
